{
  "pt": {
    "customer": {
      "actions": {
        "addCompany": "Adicionar empresa",
        "addCustomer": "Adicionar cliente",
        "addSecondaryContact": "Adicionar contacto secundário",
        "add_email_address": "Adicionar endereço de correio eletrónico",
        "bulk_import": "Clientes de importação",
        "cancel": "Anular",
        "changeProfilePicture": "Alterar a imagem do perfil",
        "createNewCustomer": "Adicionar novo cliente...",
        "goToCustomerProfile": "Ir para a página de contacto do cliente",
        "new": "Cliente",
        "profilePictureFormat": "A imagem deve ter pelo menos <strong>300x300px</strong>",
        "removeCompany": "Remover detalhes da empresa",
        "removeCustomer": "Anular a atribuição deste cliente",
        "removeSecondaryContact": "Remover o contacto secundário",
        "save": "Guardar",
        "searchCustomer": "Pesquisar cliente",
        "submit": "Guardar",
        "uploadProfilePicture": "Carregar uma imagem de perfil"
      },
      "attributes": {
        "address": "Endereço",
        "birth_date": "Data de nascimento",
        "categories": {
          "enduser": "Comprador-ocupante",
          "investor": "Investidor"
        },
        "category": "Tipo de cliente",
        "company_name": "Nome da empresa",
        "company_vat": "Número de IVA",
        "email_address": "Correio eletrónico",
        "email_address_secondary": "E-mail do contacto secundário",
        "email_notifications_interval": {
          "daily": "Uma vez por dia (por volta do meio-dia)",
          "hourly": "Cada hora",
          "twice_daily": "Duas vezes por dia (meio-dia/noite)",
          "weekly": "Uma vez por semana (segunda-feira ao meio-dia)"
        },
        "first_name": "Nome próprio",
        "iban": "IBAN",
        "internal_note": "Nota interna",
        "language": "Língua",
        "last_name": "Apelido",
        "phone_landline": "Número de telefone fixo",
        "phone_mobile": "Número de telemóvel",
        "status": "Estado"
      },
      "import": {
        "fill_customer_info": "Preencher o modelo com as informações do cliente",
        "fix_file_upload_customer": "Por favor, corrija os problemas e carregue o ficheiro novamente.</br>Os clientes existentes não serão removidos, mas serão actualizados se houver alguma alteração no ficheiro para esse cliente desde o último carregamento."
      },
      "labels": {
        "customerAddedState": "<b>Ainda não foi convidado.</b> Será enviado um e-mail de convite quando {name} tiver acesso a uma unidade atribuída.",
        "customerAddedStateNoEmailAddress": "<b>Não existe endereço de correio eletrónico conhecido.</b> É necessário um endereço de correio eletrónico para dar acesso a {name} a uma unidade atribuída.",
        "display": "Mostrar",
        "hasAccessToUnit": "Tem acesso em linha à unidade",
        "information": "As suas informações",
        "noCustomersYet": "Ainda não há clientes na plataforma",
        "noEmailAddress": "Sem endereço de correio eletrónico",
        "noProject": "Nenhum projeto ainda atribuído",
        "noUnits": "Nenhuma unidade ainda atribuída",
        "notSharedWithCustomer": "Não visível para o cliente",
        "notificationDisclaimer": "Sempre que houver novos conteúdos disponíveis para si, receberá uma notificação. Se ainda não tiver lido estas notificações na plataforma, elas serão agrupadas e enviadas por correio eletrónico. Abaixo, pode desativar as notificações sobre determinados tópicos e aumentar/diminuir a frequência das mensagens de correio eletrónico.",
        "onPlatform": "Na plataforma",
        "otherSettings": "Outras definições",
        "password": "Palavra-passe",
        "primaryContact": "Os seus dados",
        "project": "Projeto",
        "secondaryContact": "Contacto secundário",
        "sharedWithCustomer": "Visível para o cliente",
        "sorting": "Classificação",
        "units": "Unidades",
        "viaEmail": "Por correio eletrónico"
      },
      "messages": {
        "integrationUpdateInformation": "Se pretender atualizar determinadas informações, contacte-nos."
      },
      "toasts": {
        "birthday": "Feliz aniversário, {first_name}!",
        "create": "Cliente adicionado",
        "delete": "Cliente eliminado",
        "update": "Cliente atualizado",
        "upload": "Todos os clientes foram importados com sucesso"
      },
      "validation": {
        "needFirstName": "Nome próprio obrigatório",
        "needFirstNameSecondary": "Nome próprio contacto secundário necessário",
        "needLastName": "Apelido obrigatório",
        "needLastNameSecondary": "Apelido do contacto secundário necessário"
      }
    }
  }
}
